// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const StoreCategoriesTree = registerClientReference(
    function() { throw new Error("Attempted to call StoreCategoriesTree() from the server but StoreCategoriesTree is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/e-commerce/store/categories-sidebar/tree.tsx",
    "StoreCategoriesTree",
);
